export function applyCustomFont(site) {
  const fontFamily = site?.custom_font_details?.family;
  if (!fontFamily || !site?.use_custom_font) return () => {};

  const formattedFamily = fontFamily.replace(/ /g, "+");
  const fontLink = `https://fonts.googleapis.com/css2?family=${formattedFamily}&display=swap`;

  if (!document.querySelector(`link[href="${fontLink}"]`)) {
    const link = document.createElement("link");
    link.href = fontLink;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  document.body.style.fontFamily = `'${fontFamily}', ${site?.custom_font_details?.category || "sans-serif"}`;

  // Cleanup function
  return () => {
    const existingLink = document.querySelector(`link[href="${fontLink}"]`);
    if (existingLink) existingLink.remove();
    document.body.style.fontFamily = "";
  };
}
